import { NavLink } from "react-router-dom";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state";
import { motion } from "framer-motion";

export default function FamilyRegistrationAdminButton() {
  const [state, dispatch] = useSignups();
  const { canViewFamilyRegistrationAdminPanel, hasFamilyRegistration } = state;

  const hideSignupsListHolder = () => {
    dispatch({ type: "Hide Signups List Holder" });
  };

  if (!canViewFamilyRegistrationAdminPanel) return null;

  return (
    <NavLink
      to="/signups/family-registration"
      className="SignupSummary family-registration-link"
      activeClassName="on"
      data-cy="introManageFamilyRegistrationBtn"
      onClick={hideSignupsListHolder}
    >
      <div className="inside">
        <Title>
          <Icon className="fad fa-address-book" />
          <FamilyRegText>{`Manage Family & Visitor Registration`}</FamilyRegText>
        </Title>
      </div>
    </NavLink>
  );
}

const Wrapper = styled.div`
  transition: transform 0.2s;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 400;
  display: flex;
  align-items: center;
`;

const Icon = styled.i`
  margin-right: 16px;
  font-size: 24px;
`;
const FamilyRegText = styled.div`
  line-height: 26px;
`;
